/* this file is transformed by vux-loader */
/* eslint-disable */
import certification from './certification';
import common from './common';
export default {
  certification: certification,
  common: common
};